
import { Component, Inject } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Whitelabel } from '../../../models/whitelabel.model';
import { AlertService } from '../../../services/alert.service';


@Component({
    selector: 'create-edit-whitelabel-modal',
    template: require('./create-edit-whitelabel-modal.component.html'),
    styles: [require('./create-edit-whitelabel-modal.component.css')]
})
export class CreateEditWhitelabelModalComponent {
    currentWhitelabel: Whitelabel;
    isCreatNew: boolean;

    /**
     * Member portal builds a site can be put on (Whitelabel.PortalVersion). Each needs a matching
     * vN\ folder on the portal server and an entry in the portal's deploy/loader.html.
     */
    portalVersions = [
        { value: 1, name: 'v1 - Legacy' },
        { value: 2, name: 'v2 - New look' }
    ];

    constructor(private alertService: AlertService, private apiService: ApiService, public dialogRef: MatDialogRef<CreateEditWhitelabelModalComponent>,@Inject(MAT_DIALOG_DATA) public data: any) {
        this.isCreatNew = (data.currentWhitelabel.whitelabelId == undefined);
        this.currentWhitelabel = data.currentWhitelabel;
        if (!this.currentWhitelabel.portalVersion) {
            this.currentWhitelabel.portalVersion = 1;
        }
    }

    ok() {
        if (!this.isCreatNew) {
            
            this.apiService.updateWhitelabel(this.currentWhitelabel).subscribe(r => {
                if (r) {
                    this.dialogRef.close();
                    this.alertService.showMessage("Update Whitelabel successfully");
                }
            });
        } else {
            this.apiService.createWhitelabel(this.currentWhitelabel).subscribe(r => {
                if (r) {
                    this.dialogRef.close();
                    this.alertService.showMessage("Create Whitelabel successfully");
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/whitelabels/create-edit-whitelabel-modal/create-edit-whitelabel-modal.component.ts